import React from 'react';

import { Route, Redirect } from 'react-router-dom';

import { Client } from '../../Client';

const PrivateRoute = ({ component, ...rest }) => (
	<Route {...rest} render={(props) => (

		Client.isLoggedIn() ? (
			React.createElement(component, props)
		) : (
			<Redirect to={{
				pathname: '/login',
				state: { from: props.location },
			}} />
		)
	)} />
);

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/js/components/PrivateRoute/PrivateRoute.js